import React from 'react';
import { Card, Badge, Grid } from 'antd';
import ShowCompany from './ShowCompany';
import EditCompany from './EditCompany';
import DeleteCompany from './DeleteCompany';

export const CompanyCard = ({ item, onRefresh }) => {
  return (
    <Card
      title={<Badge status="processing" text={item.name} />}
      style={{
        marginBottom: 15,
        minWidth: 300,
        maxWidth: 400,
      }}
      actions={[
        <ShowCompany key="view" item={item} />,
        <EditCompany key="edit" item={item} onRefresh={onRefresh} />,
        <DeleteCompany key="delete" item={item} onRefresh={onRefresh} />,
      ]}
    >
      <p><strong>Address:</strong> {item.address}</p>
      <p><strong>URL:</strong> <a href={item.url} target="_blank" rel="noopener noreferrer">{item.url}</a></p>
      <p><strong>Description:</strong> {item.description}</p>
      <p><strong>Country:</strong> {item.country?.name}</p>
    </Card>
  );
};

export default CompanyCard;
